import { EntityType } from '@frontend/common';
import { userGroupRequest } from '@frontend/group/events';
import { IGroup } from '@frontend/group/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import {
    USER_GROUP_MEMBERS_LABEL,
    USER_GROUP_ROLES_LABEL,
    UserGroupDetailsCard,
    UserGroupMembersSection,
    UserGroupRolesAndLicensesSection
} from './user-group-detail-sections';

export const userGroupReactiveDetail: ReactiveDetailRegistryEntry<IGroup> = {
    entityType: EntityType.USER_GROUP,
    resolveFunction: userGroupRequest,
    title: ({ object }) => (
        <>
            {CommonMessage.OBJECTS.GROUP.DEFAULT}: {object.name}
        </>
    ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: ({ object }) => <UserGroupDetailsCard group={object} />
        },
        {
            id: 'members',
            label: USER_GROUP_MEMBERS_LABEL,
            render: ({ object }) => <UserGroupMembersSection group={object} />
        },
        {
            id: 'roles-and-licenses',
            label: USER_GROUP_ROLES_LABEL,
            render: ({ object }) => <UserGroupRolesAndLicensesSection group={object} />
        }
    ]
};
